import { Money } from '@/models/money';

/**
 * Possible credit statuses from API
 */
export enum CreditStatus {
  ACTIVE = 'active', // credit is active and available to use
  USED = 'used', // credit is marked as used
  CANCELLED = 'cancelled', // credit is marked as cancelled
}

export type CreditStatuses = `${CreditStatus}`;

export interface CreditResponse {
  amount: Money;
  appliedTo: string | null;
  appliedToDisplay: string;
  archived: boolean;
  brand: number | null;
  company: number;
  creditDate: string;
  // This is a slimmed down version of a customer
  customer: {
    id: number;
    displayName: string;
    extAcctId: null | string;
    delinquent: boolean;
  };
  id: number;
  notes?: string;
  order: string | null;
  orderDisplay: string | null;
  readOnly: boolean;
  reason: string;
  reasonDisplay: string;
  status: CreditStatuses;
  statusDisplay: string;
}
